import { ContentPaste } from "@mui/icons-material";
import { Button, IconButton, TableCell, Tooltip } from "@mui/material";
import { useSessionContext } from "../../../../../contexts/SessionContext";
import { useEhrRecordsMobileLayout } from "../../../context/EhrRecordsLayoutContext";
import {
  EhrMobileActionStack,
  ehrMobileActionBtnSx,
} from "../../mobile/EhrMobileActionStack";

export function AllergiesActions({
  row,
  openVisualizer,
  verifyVisualizer,
}: any) {
  const { access } = useSessionContext();
  const isEhrMobileCard = useEhrRecordsMobileLayout();
  const canViewEncounter =
    verifyVisualizer &&
    verifyVisualizer(row?.encounterId) &&
    access?.type === "professional";

  if (isEhrMobileCard) {
    if (!canViewEncounter) return null;
    return (
      <EhrMobileActionStack>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          startIcon={<ContentPaste />}
          sx={ehrMobileActionBtnSx}
          onClick={() => {
            openVisualizer(row?.encounterId);
          }}
        >
          Visualizar atendimento
        </Button>
      </EhrMobileActionStack>
    );
  }

  return (
    <TableCell align="center">
      {canViewEncounter ? (
        <Tooltip title="Visualizar atendimento">
          <IconButton
            onClick={() => {
              openVisualizer(row?.encounterId);
            }}
          >
            <ContentPaste />
          </IconButton>
        </Tooltip>
      ) : null}
    </TableCell>
  );
}
